// Frontend Environment Configuration Loader
// This file provides a unified interface to access environment configuration
// All configuration is loaded from .env file via webpack DefinePlugin

import envConfig from './env.js';

/**
 * Get environment configuration
 * All values are loaded from .env file via webpack DefinePlugin
 */
export function getEnvironmentConfig() {
  return envConfig;
}

/**
 * Synchronous version for immediate use
 */
export function getEnvironmentConfigSync() {
  return envConfig;
}

/**
 * Helper function to determine if we're in local development
 */
export function isLocalDevelopment() {
  return window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1';
}

/**
 * Get the appropriate API endpoint based on environment
 * Uses configuration from .env file
 */
export function getApiEndpoint() {
  const config = getEnvironmentConfig();
  return config.API_ENDPOINT || config.API || '';
}

/**
 * Get the appropriate WebSocket URL based on environment
 * Uses configuration from .env file
 */
export function getWebSocketUrl() {
  const config = getEnvironmentConfig();
  return config.WS_URL || '';
}

/**
 * Get the appropriate GraphQL endpoint based on environment
 * Uses configuration from .env file
 */
export function getGraphQLEndpoint() {
  const config = getEnvironmentConfig();
  return config.GRAPHQL_ENDPOINT || '';
}

// Export default config for convenience
export default envConfig;



// WEBPACK FOOTER //
// ./src/config/environment.js